import { render, staticRenderFns } from "./BMWMotorradCustomerTreatmentColumn.vue?vue&type=template&id=328dd50e&scoped=true&"
import script from "./BMWMotorradCustomerTreatmentColumn.vue?vue&type=script&lang=js&"
export * from "./BMWMotorradCustomerTreatmentColumn.vue?vue&type=script&lang=js&"
import style0 from "./BMWMotorradCustomerTreatmentColumn.vue?vue&type=style&index=0&id=328dd50e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328dd50e",
  null
  
)

export default component.exports